import { renderIsomorphicComponent, renderComponent, renderBreakingNews } from "@quintype/framework/client/start";
import get from "lodash/get";

import { pickComponent } from "../isomorphic/pick-component";
import LoadingIndicatorComponent from "../isomorphic/components/atoms/loading-indicator";
import { Header } from "../isomorphic/components/header";
import { RenderFooter } from "../isomorphic/components/layouts/footer/render-footer-component";
import BreakingNewsSliderView from "../isomorphic/components/BreakingNewsSlider";

import { getUser, getJwt } from "../isomorphic/components/helper/api";
import { setMember, setJwtToken } from "../isomorphic/components/helper/actions";

export function preRenderApplication(store) {
  const integrationsId = get(store.getState(), ["qt", "config", "publisher-attributes", "integrations_id"], null);
  getUser()
    .then(response => {
      store.dispatch(setMember(response.member));

      getJwt(integrationsId).then(res => {
        if (res.status === 200) {
          store.dispatch(setJwtToken(res.headers.get("x-integration-token")));
        }
      });
    })
    .catch(ex => console.log(ex.message))
    .finally(() => {
      const pageType = get(store.getState(), ["qt", "pageType"], null);
      const hydrate = { hydrate: !global.qtLoadedFromShell };
      if (pageType === "story-preview" || pageType === "static-page") {
        renderComponent(Header, "header", store, hydrate);
      }
      renderComponent(RenderFooter, "footer", store, hydrate);
      renderComponent(LoadingIndicatorComponent, "loading-indicator", store);
    });
}

// This is a separate file as everything from here on is hot reloaded when the app changes
export function renderApplication(store) {
  const domainSlug = get(store.getState(), ["qt", "config", "domainSlug"], null);
  const hydrate = { hydrate: !global.qtLoadedFromShell };
  if (!domainSlug) {
    renderBreakingNews("breaking-news-container", store, BreakingNewsSliderView, hydrate);
  }
  renderIsomorphicComponent("container", store, pickComponent, {
    hydrate: !global.qtLoadedFromShell
  });
}
